import React from 'react';
import { Modal } from '../Shared/Modal';
import { RepliCloudFAQsModal } from '../FAQ/RepliCloudFAQsModal';
import { ui } from '../../../config/uiSizes';

interface PreMigrationConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onBack?: () => void;
  confirmLoading?: boolean;
}

export const PreMigrationConfirmModal: React.FC<PreMigrationConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  onBack,
  confirmLoading = false
}) => {
  const [faqOpen, setFaqOpen] = React.useState(false);

  return (
    <>
      <Modal
        isOpen={isOpen && !faqOpen}
        variant="preMigrationConfirm"
        title="Pre-Migration Confirmation"
        onClose={onClose}
        showCloseButton={true}
        showIcon={false}
        showConfirmButton={false}
        customButtons={
          <>
            {onBack && (
              <button
                type="button"
                onClick={onBack}
                disabled={confirmLoading}
                className={`flex-1 ${ui.button.modalButton} rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 font-semibold shadow transition hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-60 disabled:cursor-not-allowed`}
              >
                Back
              </button>
            )}
            <button
              type="button"
              onClick={onConfirm}
              disabled={confirmLoading}
              className={`flex-1 ${ui.button.modalButton} bg-green-600 hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-600 text-white font-semibold rounded-lg shadow-md transition-all disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center ${ui.gap.sm}`}
            >
              {confirmLoading && (
                <svg
                  className={`animate-spin ${ui.svg.sm}`}
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                    fill="none"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
              )}
              {confirmLoading ? 'Starting Migration...' : 'Continue Migration'}
            </button>
          </>
        }
      >
        <div className={`text-center space-y-3 ${ui.text.body}`}>
          <p className="font-bold text-gray-800 dark:text-gray-100">
            Are you sure you want to continue?
          </p>
          <p className="text-blue-600 dark:text-blue-400 italic">
            Previously selected changes will be made in Genesys Cloud.
          </p>
          <p className="text-gray-500 dark:text-gray-400">
            Please read the{' '}
            <button
              type="button"
              onClick={() => setFaqOpen(true)}
              className="text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300 transition-colors"
            >
              FAQ
            </button>
          </p>
        </div>
      </Modal>
      <RepliCloudFAQsModal
        isOpen={isOpen && faqOpen}
        onClose={() => { setFaqOpen(false); onClose(); }}
        onBack={() => setFaqOpen(false)}
      />
    </>
  );
};
